import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  CREATE_FUND_ACCOUNT_BANK_ACTIONS,
  CREATE_FUND_ACCOUNT_VPA_ACTIONS,
  GET_FUND_ACCOUNTS_ACTIONS,
  WITHDRAW_MONEY_ACTIONS,
} from "../reducers/actionTypes";
import {
  createFundAccountBank,
  editUserFundAccount,
  getFundAccounts,
  withdrawMoney,
} from "../services/api";
import { actions } from "../reducers/oldWalletReducer";
import AsyncStorage from "@react-native-async-storage/async-storage";
import analytics from "@react-native-firebase/analytics";
import { ToastAndroid } from "react-native";
import { AppEventsLogger } from "react-native-fbsdk-next";
import t from "@constants/localization";
import { navigate } from "@navigation";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import getLocationAndIdentifers from "@utils/getLocationAndIdentifers";

function* fetchFundAccounts() {
  try {
    const { data } = yield call(getFundAccounts);
    yield put(actions.fetchedFundAccounts(data));
  } catch (error) {
    yield put(actions.failedFetchFundAccounts(error.response.data));
  }
}

function* addBankAccount({ payload }) {
  yield put(snackbarActions.resetSnackbar());
  let finalData = yield call(getLocationAndIdentifers);
  payload = { ...payload, ...finalData };
  try {
    if (payload.edit) {
      delete payload.edit;
      const { data } = yield call(editUserFundAccount, payload);

      if (payload.account_type == "vpa") {
        yield put(actions.createdFundAccountVpa({ createAccountResult: data }));
      } else {
        yield put(actions.createdFundAccountBank(data));
        const snackbarPayload = {
          message: t("gullak/accountAddedSuccessfully"),
          bottom: 0,
        };
        yield put(snackbarActions.showSnackbar(snackbarPayload));
      }
    } else {
      const { data } = yield call(createFundAccountBank, payload);
      yield put(actions.createdFundAccountBank(data));
      const snackbarPayload = {
        message: t("gullak/accountAddedSuccessfully"),
        bottom: 0,
      };
      yield put(snackbarActions.showSnackbar(snackbarPayload));
    }
  } catch (error) {
    yield put(actions.failedCreateFundAccountBank(error.response.data));
    if (
      error.response.data.error &&
      error.response.data.error === "INVALID_OTP"
    )
      return;
    navigate("AddBankDetails");
    const errorMessage =
      error.response.data?.createAccountResult?.errors?.upi_address?.message ??
      "";
    if (errorMessage)
      ToastAndroid.show(errorMessage, ToastAndroid.SHORT, ToastAndroid.TOP);
  }
}

function* addVpaAccount({ payload }) {
  yield put(snackbarActions.resetSnackbar());
  let finalData = yield call(getLocationAndIdentifers);
  payload = { ...payload, ...finalData };
  let data;
  try {
    const { data: dataRes } = yield call(createFundAccountBank, payload);
    data = dataRes;
    yield put(actions.createdFundAccountVpa(data));
    const snackbarPayload = {
      message: t("gullak/accountAddedSuccessfully"),
      bottom: 0,
    };
    yield put(snackbarActions.showSnackbar(snackbarPayload));
  } catch (error) {
    yield all([put(actions.failedCreateFundAccountVpa(error.response.data))]);
    if (
      error.response.data.error &&
      error.response.data.error === "INVALID_OTP"
    )
      return;
    navigate("AddNewUpi");
    const errorMessage =
      error.response.data?.createAccountResult?.errors?.upi_address?.message ??
      "";
    if (errorMessage)
      ToastAndroid.show(errorMessage, ToastAndroid.SHORT, ToastAndroid.TOP);
  }
}

function* withdrawMoneyToBank({ payload }) {
  try {
    const { data } = yield call(withdrawMoney, payload);
    const isMoneyWithdrawed = yield AsyncStorage.getItem("isMoneyWithdrawed");
    if (!isMoneyWithdrawed) {
      AppEventsLogger.logEvent("fb_first_gullak_withdrawl", {});
      analytics().logEvent("google_first_gullak_withdrawl");
      yield AsyncStorage.setItem("isMoneyWithdrawed", "true");
    }
    yield put(actions.successWithdrawMoney(data));
  } catch (error) {
    yield put(actions.failedWithdrawMoney(error.response.data));
  }
}

export default function* () {
  yield takeLatest(
    GET_FUND_ACCOUNTS_ACTIONS.FETCH_FUND_ACCOUNTS,
    fetchFundAccounts,
  );
  yield takeEvery(
    CREATE_FUND_ACCOUNT_BANK_ACTIONS.CREATE_FUND_ACCOUNT,
    addBankAccount,
  );
  yield takeEvery(
    CREATE_FUND_ACCOUNT_VPA_ACTIONS.CREATE_VPA_FUND_ACCOUNT,
    addVpaAccount,
  );
  yield takeLatest(WITHDRAW_MONEY_ACTIONS.WITHDRAW_MONEY, withdrawMoneyToBank);
}
